"use strict";

exports.__esModule = true;
exports.DashManifestParser = void 0;
var _YoLog = require("../Utils/YoLog");
var _PlaylistPayload = require("./PlaylistPayload");
var _sax = _interopRequireDefault(require("sax"));
var _Constant = require("../Utils/Constant");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
 * COPYRIGHT 2020-2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */

var YOJS_LOCATION_PATTERN = "yo.js=([^&]+)";
var JSESS_LOCATION_PATTERN = "\/live\/(\\d+)\/.+?;jsessionid=([^?\\s]+)";
var INTER_SEGMENT_TIMEOUT_DASH = 1600;
var YO_JS = "yo.js";
var DashManifestParser = exports.DashManifestParser = /*#__PURE__*/function () {
  function DashManifestParser() {
    this.data = new Map();
    this.s = "";
    this.error = null;
    this.onError = this.onError.bind(this);
    this.onText = this.onText.bind(this);
    this.onOpenTag = this.onOpenTag.bind(this);
    this.onCloseTag = this.onCloseTag.bind(this);
    this.onCdata = this.onCdata.bind(this);
  }
  DashManifestParser.parse = function parse(dashBytes) {
    if (!dashBytes || dashBytes.length === 0) {
      _YoLog.YoLog.e("Yospace DASH manifest is empty");
      return null;
    }
    var parser = new DashManifestParser();
    return parser.parse(dashBytes);
  };
  var _proto = DashManifestParser.prototype;
  _proto.parse = function parse(dashBytes) {
    var parser = _sax["default"].parser(true);
    parser.onerror = this.onError;
    parser.ontext = this.onText;
    parser.onopentag = this.onOpenTag;
    parser.onclosetag = this.onCloseTag;
    parser.oncdata = this.onCdata;
    parser.write(dashBytes);
    if (this.error) {
      return null;
    }
    return new _PlaylistPayload.PlaylistPayload(this.data, INTER_SEGMENT_TIMEOUT_DASH);
  };
  _proto.onCdata = function onCdata(data) {
    this.s += data;
  };
  _proto.onError = function onError() {
    this.error = true;
  };
  _proto.onCloseTag = function onCloseTag(tag) {
    if (tag.toUpperCase() === "LOCATION") {
      var location = this.s.trim();
      this.data.set(_Constant.Payload.LOCATION, location);
      var loc = location.split(/\?/);
      try {
        var url = new URL(loc[0]);
        this.data.set(_Constant.Payload.SCHEME, url.protocol.substring(0, url.protocol.length - 1));
        this.data.set(_Constant.Payload.HOSTNODE, url.hostname);
        this.data.set(_Constant.Payload.PORT, url.port);
        this.data.set(_Constant.Payload.QS, loc.length === 2 ? loc[1] : null);

        // parse out the identifiers
        var jsessLocationMatch = loc[0].match(JSESS_LOCATION_PATTERN);
        if (jsessLocationMatch) {
          this.data.set(_Constant.Payload.IDENTIFIER, jsessLocationMatch[2]);
        } else {
          if (location.indexOf(YO_JS) !== -1) {
            var yojsLocationMatch = location.match(YOJS_LOCATION_PATTERN);
            if (yojsLocationMatch) {
              this.data.set(_Constant.Payload.IDENTIFIER, yojsLocationMatch[1]);
            }
          }
        }
        if (this.data.get(_Constant.Payload.IDENTIFIER) === undefined) {
          this.error = true;
        }
      } catch (e) {
        _YoLog.YoLog.e("Failed to parse Location element: " + e);
        this.error = true;
      }
    }
  };
  _proto.onOpenTag = function onOpenTag(node) {
    this.s = "";
    if (node.name.toUpperCase() === "MPD") {
      this.data.set(_Constant.Payload.ANALYTICURL, node.attributes.analytics);
      this.data.set(_Constant.Payload.PAUSEURL, node.attributes.livePause);
      this.data.set(_Constant.Payload.AVAILABILITYSTART, new Date(node.attributes.availabilityStartTime));
    }
  };
  _proto.onText = function onText(text) {
    this.s = text;
  };
  return DashManifestParser;
}();